import React, { useEffect, useRef, useMemo } from "react";
import * as echarts from 'echarts';
import configuartionConfig from "./ConfigurationConfig.json"

function ConfigurationChangeEvent() {
  const chartRef = useRef(null);

  const mockLoginData = [
    { time: "17:00", Configuration: 7, Alarm: 4 },
    { time: "18:00", Configuration: 7, Alarm: 5 },
    { time: "19:00", Configuration: 3, Alarm: 4 },
    { time: "20:00", Configuration: 2, Alarm: 2 },
    { time: "21:00", Configuration: 4, Alarm: 4 },
    { time: "22:00", Configuration: 5, Alarm: 5 }
  ];

  const chartOptions = useMemo(() => {
    return {
      tooltip: {
        trigger: configuartionConfig.chartConfig.tooltip.trigger,
        axisPointer: {
          type: configuartionConfig.chartConfig.tooltip.axisPointer.type
        },
        formatter: function (params) {
          const time = params[0].name;
          const dataItem = mockLoginData.find(item => item.time === time);
          if (!dataItem) return '';

          let tooltipContent = `<strong>${time}</strong><br/>`;
          params.forEach(param => {
            tooltipContent += `
              <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${param.color};"></span>
              ${param.seriesName}: ${param.value}<br/>
            `;
          });
          return tooltipContent;
        },
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderWidth: 1,
        padding: [10, 10, 10, 10],
        textStyle: {
          color: '#333'
        }
      },
      // legend: {
      //   data: [
      //     { name: 'Configuration', icon: 'rect' },
      //     { name: 'Alarm', icon: 'rect' }
      //   ],
      //   top: '3%',
      //   right: '5%',
      //   itemGap: 15,
      //   textStyle: {
      //     color: '#333',
      //     fontSize: 12
      //   }
      // },
      legend: configuartionConfig.chartConfig.legend,
      grid: {
        left: configuartionConfig.chartConfig.grid.left,
        right: configuartionConfig.chartConfig.grid.right,
        bottom: configuartionConfig.chartConfig.grid.bottom,
        top: configuartionConfig.chartConfig.grid.top,
        containLabel: true,
        show: true,
        borderWidth: configuartionConfig.chartConfig.grid.borderWidth,
        splitLine: {
          show: true,
          lineStyle: {
            color: '#ddd',
            type: 'dashed',
            opacity: 0.7
          }
        }
      },
      xAxis: {
        type: configuartionConfig.chartConfig.xAxis.type,
        data: mockLoginData.map(item => item.time),
        axisLabel: {
          show: true,
          color: '#555',
          fontSize: 12
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#999'
          }
        },
        name: configuartionConfig.chartConfig.xAxis.name,
        nameLocation: configuartionConfig.chartConfig.xAxis.nameLocation,
        nameGap:configuartionConfig.chartConfig.xAxis.nameGap,
        nameTextStyle: {
          color: '#333',
          fontSize: 14,
          fontWeight: 'bold',
        }
      },
      yAxis: {
        type: configuartionConfig.chartConfig.yAxis.type,
        axisLabel: {
          show: true,
          color: '#555',
          fontSize: 12
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        name: configuartionConfig.chartConfig.yAxis.name,
        nameLocation:configuartionConfig.chartConfig.yAxis.nameLocation,
        nameRotate: configuartionConfig.chartConfig.yAxis.nameRotate,
        nameGap: configuartionConfig.chartConfig.yAxis.nameGap,
        nameTextStyle: {
          color: '#333',
          fontSize: 14,
          fontWeight: 'bold'
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#ddd',
            type: 'dashed',
            opacity: 0.7
          }
        }
      },
      series: [
        {
          name: configuartionConfig.chartConfig.series[0].name,
          type: configuartionConfig.chartConfig.series[0].type,
          data: mockLoginData.map(item => item.Configuration),
          itemStyle: {
            color: '#FF4C4C'
          },
          barWidth: configuartionConfig.chartConfig.series[0].barWidth,
          barGap: configuartionConfig.chartConfig.series[0].barGap
        },
        {
          name: configuartionConfig.chartConfig.series[1].name,
          type: configuartionConfig.chartConfig.series[1].type,
          data: mockLoginData.map(item => item.Alarm),
          itemStyle: {
            color: '#b85c00'
          },
          barWidth: 18,
          barGap: configuartionConfig.chartConfig.series[1].barGap
        }
      ]
    };
  }, [mockLoginData]);

  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current);
      chart.setOption(chartOptions);

      const handleResize = () => {
        chart.resize();
      };
      window.addEventListener('resize', handleResize);

      return () => {
        chart.dispose();
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [chartOptions]);

  return (
    <div
      ref={chartRef}
      style={{
        margin: "20px auto",
        width: "100%", 
        marginTop: "10px",
        maxWidth: "800px", 
        marginLeft: "10px",
        height: "200px"
      }}
    />
  );
}

export default ConfigurationChangeEvent;